import localConfigs from 'configs.local';
import _ from 'lodash';

const allConfigs = {
  dev: {
    env: 'dev',
    scrollingUrl: 'https://panels-dev.athlinks.com',
    apiBaseUrl: 'https://api-qa.chronotrack.com/api',
  },
  stage: {
    env: 'stage',
    scrollingUrl: 'https://panels-stage.athlinks.com',
    apiBaseUrl: 'https://api-qa.chronotrack.com/api',
  },
  prod: {
    env: 'prod',
    scrollingUrl: 'https://panels.athlinks.com',
    apiBaseUrl: 'https://api.chronotrack.com/api',
  },
  all: {
    // Here you can put
  }
};

function getConfigs() {
  const envServiceTag = window.config && window.config.serviceTag;

  // Comes from node.js server. you can console.log(config) to see all.
  if(__DEVELOPMENT__) {
    return _.assign({}, allConfigs.all, localConfigs);
  }

  if(process.env.SERVICE_TAGS === 'athlinks-dev' || envServiceTag == 'athlinks-dev') {
    return _.assign({}, allConfigs.all, allConfigs.dev);
  }

  if(process.env.SERVICE_TAGS === 'athlinks-test' || envServiceTag == 'athlinks-test') {
    return _.assign({}, allConfigs.all, allConfigs.test);
  }

  if(process.env.SERVICE_TAGS === 'athlinks-stage' || envServiceTag == 'athlinks-stage') {
    return _.assign({}, allConfigs.all, allConfigs.stage);
  }

  return _.assign({}, allConfigs.all, allConfigs.prod);
}

export const configs = getConfigs();



// WEBPACK FOOTER //
// ./configs.js